import React from 'react';

import { token } from '@atlaskit/tokens';
import type { IconProps } from '@atlaskit/icon';
import Icon from '@atlaskit/icon';

const LightningGlyph = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M14.6392 6.956C14.5743 6.78222 14.4081 6.66667 14.2223 6.66667H8.85565L11.9512 0.648C12.0485 0.458667 11.9983 0.227111 11.8308 0.0955556C11.7499 0.0315556 11.6525 0 11.5556 0C11.4521 0 11.3485 0.0364444 11.2654 0.108L8.00009 2.928L1.48765 8.55244C1.3472 8.67378 1.29653 8.86978 1.36142 9.04356C1.42631 9.21733 1.59209 9.33333 1.77787 9.33333H7.14454L4.04898 15.352C3.95165 15.5413 4.00187 15.7729 4.16942 15.9044C4.25031 15.9684 4.34765 16 4.44453 16C4.54809 16 4.65165 15.9636 4.73476 15.892L8.00009 13.072L14.5125 7.44756C14.6534 7.32622 14.7036 7.13022 14.6392 6.956V6.956Z"
			fill={token('color.background.accent.teal.bolder')}
		/>
	</svg>
);

export type LightningIconProps = Omit<IconProps, 'glyph'>;

export const LightningIcon = (props: LightningIconProps) => (
	<Icon glyph={LightningGlyph} testId="lightning-icon" {...props} />
);
